export const MarketingChannelStatus = {
  Subscribed: 'subscribed',
  Unsubscribed: 'unsubscribed',
}
